document.addEventListener("DOMContentLoaded", () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const el = entry.target;
        const bg = el.dataset.bg;
        if (bg) {
          el.style.backgroundImage = `url('${bg}')`;
          el.classList.add("loaded");
          observer.unobserve(el); // Stop watching once loaded
        }
      }
    });
  });

  document.querySelectorAll(".lazyload").forEach(el => observer.observe(el));
});